module.exports = __webpack_public_path__ + "img/safari.0ecea45c.png";